import React from 'react';
import { Button } from '@weirgroup/one-weir';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styles from './stickymessage.module.css';
import InfoIcon from '../../resources/images/Info.svg';
import { useMsal } from '@azure/msal-react';
/* 
StickyMessagebar component requires two props for logout and infomodal popup, this uses i18n for the text content.
*/
function StickyMessage(props) {
  const { instance, accounts } = useMsal();
  const { t } = useTranslation();
  const { isAuthenticated } = props;

  return (
    <>
      {isAuthenticated && (
        <div className={styles.messageBar} id="stickyMessageBar">
          <div className={styles.messageContainer}>
            <p data-testid="messagebarText" className={styles.messageBarText}>
              {t('messagebarText')}
            </p>
          </div>

          <div className={styles.buttonContainer}>
            <Button
              data-testid="signout"
              label={t('btnSignOutLbl')}
              style={{
                width: '152px',
                height: '45px',
                marginRight: '20px',
                marginTop: '0px',
                marginBottom: '0px',
              }}
              onClick={() => {
                //instance.logoutRedirect();
                // props.logout();
                instance.logoutRedirect({
                  account: accounts[0],
                  postLogoutRedirectUri: '/kiosk', // your route
                });
              }}
            />
            <div
              data-testid="infobutton"
              tabIndex="0"
              className={styles.icon}
              aria-hidden="true"
              onClick={() => props.showModal(true)}
            >
              <img className={styles.img} src={InfoIcon} alt="info" />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.AuthReducer.isAuthenticated,
  };
};

export default connect(mapStateToProps)(StickyMessage);
